import { Box } from '@mui/material';
import { PropsWithChildren, memo } from 'react';
import { SEVERITY_COLORS, Severity } from '../../enums/Severity';

type Props = PropsWithChildren<{ severity: Severity }>;

export const SeverityBadge = memo(({ children, severity }: Props) => {
  return (
    <Box className="severity-badge" sx={{ position: 'relative', px: 1.5, py: 0.25, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Box
        sx={{
          border: `2px solid`,
          position: 'absolute',
          top: 0,
          bottom: 0,
          right: 0,
          left: 0,
          borderRadius: '5px',
          color: SEVERITY_COLORS[severity].text,
          backgroundColor: SEVERITY_COLORS[severity].background,
          borderColor: SEVERITY_COLORS[severity].main,
        }}
      />
      <Box sx={{ zIndex: 1 }}>{children}</Box>
    </Box>
  );
});
